/**
 * @fileoverview POST handler for the "/integrations/voucher_groups/:id/:app_group_id/unused_voucher_codes_export" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportCacheKeys } from "./constants";
import type {
  PostIntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportProps,
  IntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportResult,
} from "./types";

export const postIntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExport = reactQueryMutationAdapter(
  integrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportCacheKeys,
  (
    props: PostIntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportProps
  ): Promise<IntegrationsVoucherGroupsIdAppGroupIdUnusedVoucherCodesExportResult> => {
    return fetch(
      `/integrations/voucher_groups/${props.id}/${props.appGroupId}/unused_voucher_codes_export`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
